// @flow

/**
 * Escapes HTML characters within the text.
 * Useful if you are doing dangerouslySetInnerHTML with an unsafe string (e.g. any user-written text)
 * Common use-case is with import { localize, unescaped } from '@ta/common.i18n' where an unescaped unsafe string (e.g user's displayName) is being passed as an argument
 *
 * @param {string} text - The text to escape
 */
const escapeHtml = (text: ?string) => {
  if (!text) {
    return '';
  }
  return text.replace(/[<>&"'`]/g, match => {
    const escape = {
      '<': '&lt;',
      '>': '&gt;',
      '&': '&amp;',
      '"': '&quot;',
      "'": '&#39;',
      '`': '&#x60;', // Apparently some IE versions use this character to quote attributes
    };
    return escape[match];
  });
};

export default escapeHtml;
